module.exports = __webpack_public_path__ + "6b025683c217e7266f5fbb1c7960fc04.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/key-art-1080.mp4
// module id = 636
// module chunks = 0